import { css } from "@emotion/css";
import { ExternalLink } from "@octopusdeploy/design-system-components";
import { fontWeight, themeTokens } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
import { ExternalLinkSlugs } from "~/areas/infrastructure/components/ArgoCDInstances/ArgoCDConstants";
import ConfigurationViewHelpImageSvg from "~/areas/infrastructure/components/ArgoCDInstances/DialogViews/components/ConfigurationViewHelpImage.svg";
import InstallationViewHelpImageSvg from "~/areas/infrastructure/components/ArgoCDInstances/DialogViews/components/InstallationViewHelpImage.svg";
import type { HelpPanelImage } from "~/components/OnboardingDialog/HelpPanel";
const helpStyles = {
    content: css({ marginTop: 0, h2: { marginTop: 0, fontWeight: fontWeight["700"], color: themeTokens.color.dialog.helpPanel.text }, p: { color: themeTokens.color.dialog.helpPanel.text } }),
};
const DocsLink = <ExternalLink href={ExternalLinkSlugs.ArgoGatewayInstallationDocs}>View installation docs</ExternalLink>;
export const ConfigurationViewHelpContent = (<span className={helpStyles.content}>
        <h2>Connect Octopus to your Argo CD GitOps workflows</h2>
        <p>Provide details about your Argo CD instance to get started.</p>
        <p>On the next screen, we'll generate a custom Helm command to install the Octopus gateway.</p>
        <p>{DocsLink}</p>
    </span>);
export const ConfigurationViewHelpImage: HelpPanelImage = {
    altText: "Octopus connects to your Argo CD GitOps workflows",
    src: ConfigurationViewHelpImageSvg,
};
export const InstallationViewHelpContent = (<span className={helpStyles.content}>
        <h2>Keeping Octopus & Argo CD in sync</h2>
        <p>The gateway is a secure bridge between Octopus Deploy and your Argo CD instance.</p>
        <p>It syncs application mappings without Octopus needing direct access to your cluster.</p>
        <p>After installation, your Argo CD instance will be automatically registered in Octopus.</p>
        <p>{DocsLink}</p>
    </span>);
export const InstallationViewHelpImage: HelpPanelImage = {
    altText: "The Octopus gateway connects Octopus Deploy to your Argo CD instance",
    src: InstallationViewHelpImageSvg,
};
